// FavoritesContext.tsx
import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from "react";
import { AthleteDTO } from "../interfaces/AthletesDTO";

interface FavoritesContextProps {
  favorites: number[];
  addFavorite: (athleteID: number) => void;
  removeFavorite: (athleteId: number) => void;
  setRaceID: (raceID: number) => void;
  setAthleteInfo: (athleteInfo: string[]) => void;
  getAthleteInfo: (startno: number) => string;
  getAthleteInfoFIS: (fiscode: number | null) => string;
}

const FavoritesContext = createContext<FavoritesContextProps | undefined>(
  undefined
);

interface FavoritesProviderProps {
  children: ReactNode;
}

export const FavoritesProvider: React.FC<FavoritesProviderProps> = ({
  children,
}) => {
  const [favorites, setFavorites] = useState<number[]>([]);
  const [raceIDs, setRaceIDs] = useState<number>(-1);
  const [athleteInfoFile, setAthleteInfoFile] = useState<string[]>([]);
  const addFavorite = (athleteID: number) => {
    if (!favorites.some((fav) => fav === athleteID)) {
      // check if athlete isn't already in favorites
      setFavorites((prev) => [...prev, athleteID]);
    }
  };

  const setRaceID = (rid: number) => {
    setRaceIDs(rid);
    loadFavorites();
  };

  const removeFavorite = (athleteId: number) => {
    setFavorites((prev) => prev.filter((athlete) => athlete !== athleteId));
  };
  const setAthleteInfo = (athInf: string[]) => {
    setAthleteInfoFile(athInf);
  };
  const getAthleteInfo = (strn: number): string => {
    let Data = "";
    athleteInfoFile.map((obj) => {
      let splited = obj.split(";");
      if (splited[0] == strn.toString()){
        Data = splited.reverse()[0];
        return true;
      }
    });

    return Data;
  };
  const getAthleteInfoFIS = (fiscode:number | null): string => {
    if (!fiscode) return ""; 
      
    let Data = "";
    athleteInfoFile.map((obj) => {
      let splited = obj.split(";");
      if (splited[0] == fiscode.toString()){
        Data = splited.reverse()[0];
        return true;
      }
    });

    return Data;
  };
  useEffect(() => {
    saveFavorites();
  }, [favorites]);
  const loadFavorites = () => {
    let storedFavorites: string | null = localStorage.getItem(
      "favorites_" + raceIDs
    );
    if (storedFavorites !== null) {
      setFavorites(JSON.parse(storedFavorites));
    }
  };

  const saveFavorites = () => {
    if (raceIDs !== -1) {
      // favorites.filter((value, index, array) => array.indexOf(value) === index);
      localStorage.setItem(
        "favorites_" + raceIDs,
        JSON.stringify(
          favorites.filter(
            (value, index, array) => array.indexOf(value) === index
          )
        )
      );
    }
  };

  return (
    <FavoritesContext.Provider
      value={{ favorites, addFavorite, removeFavorite, setRaceID,setAthleteInfo, getAthleteInfo,getAthleteInfoFIS }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = (): FavoritesContextProps => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error("useFavorites must be used within a FavoritesProvider");
  }
  return context;
};
